import { withTranslation } from "react-i18next";

import { Modal } from "reactstrap";
import { ModalBody } from "reactstrap";
import crossIcon from "assets/images/cross.svg";
import Text from "components/Text";
import styles from "../AddEvent.module.scss";
import userDefaultImage from "assets/images/staff-default-rounded.png";

function ViewEmployeeModal({
  t,
  issaveEmployeeModalOpen,
  setIsSaveEmployeeModalOpen,
  allMembersList,
  isFromBusySlotdetail = false,
}) {
  return (
    <>
      <Modal
        isOpen={issaveEmployeeModalOpen}
        toggle={() => setIsSaveEmployeeModalOpen(false)}
        className={
          "modal-dialog-centered " + styles["add-employee-modal-dialog"]
        }
        modalClassName="custom-modal"
      >
        <span
          className="close-btn"
          onClick={() => setIsSaveEmployeeModalOpen(false)}
        >
          <img src={crossIcon} alt="close" />
        </span>
        <ModalBody>
          <Text size="25px" marginBottom="10px" weight="500" color="#111b45">
            <span className="modal-title-25">
              {" "}
              {t("accountOwner.notifyEmployees")}
            </span>
          </Text>

          <ul className={"modal-employee-list " + styles["employee-list"]}>
            {allMembersList.length > 0 &&
              allMembersList.map((val, key) => (
                <li key={key}>
                  <div>
                    <label>
                      <div className="d-flex flex-row align-items-center">
                        {" "}
                        <img
                          src={val?.user?.profilePic || userDefaultImage}
                          width={40}
                          height={40}
                          className={styles.image_style}
                          alt="profile"
                        />
                        <div className="d-flex flex-column ml-2">
                          <Text size="14px" weight="600" color="#102C42">
                            {val?.user?.firstName} {val?.user?.lastName}{" "}
                          </Text>

                          {isFromBusySlotdetail && (
                            <Text size="12px" weight="400" color="#87928D">
                              {`${val?.user?.designation?.name}, ${val?.office?.name}`}
                            </Text>
                          )}
                        </div>
                      </div>
                    </label>
                  </div>
                </li>
              ))}
            {allMembersList.length === 0 && (
              <li>
                <div className="ch-checkbox">
                  <label>{t("noRecordFound")}</label>
                </div>
              </li>
            )}
          </ul>
        </ModalBody>
      </Modal>
    </>
  );
}

export default withTranslation()(ViewEmployeeModal);
